export var SpectrumQueryKey;
(function (SpectrumQueryKey) {
    SpectrumQueryKey["Product"] = "p";
    SpectrumQueryKey["Node"] = "n";
    SpectrumQueryKey["LightSpectrum"] = "l";
    SpectrumQueryKey["AbsorptionSpectrum"] = "a";
    SpectrumQueryKey["Weight"] = "w";
    SpectrumQueryKey["FancyGreyStrength"] = "fg";
    SpectrumQueryKey["Panorama"] = "pm";
    SpectrumQueryKey["Stereo"] = "s";
    SpectrumQueryKey["PageView"] = "pv";
    SpectrumQueryKey["ComparatorProduct"] = "c_p";
    SpectrumQueryKey["ComparatorNode"] = "c_n";
    SpectrumQueryKey["ComparatorLightSpectrum"] = "c_l";
    SpectrumQueryKey["ComparatorAbsorptionSpectrum"] = "c_a";
    SpectrumQueryKey["ComparatorWeight"] = "c_w";
    SpectrumQueryKey["ComparatorFancyGreyStrength"] = "c_fg";
    SpectrumQueryKey["ComparatorPanorama"] = "c_pm";
    SpectrumQueryKey["ComparatorStereo"] = "c_s";
    SpectrumQueryKey["ComparatorPageView"] = "c_pv";
    SpectrumQueryKey["LensFValue"] = "f";
    SpectrumQueryKey["PixelRatio"] = "pr";
    SpectrumQueryKey["Debug"] = "debug";
    SpectrumQueryKey["Compare"] = "compare";
    SpectrumQueryKey["Develop"] = "dev";
    SpectrumQueryKey["Edit"] = "edit";
})(SpectrumQueryKey || (SpectrumQueryKey = {}));
